module.exports = __webpack_public_path__ + "deee42585cb306cf53c3a9a973f2e1c0.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-20.cur
// module id = 446
// module chunks = 0